exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-[address]-tsx": () => import("./../../../src/pages/[address].tsx" /* webpackChunkName: "component---src-pages-[address]-tsx" */),
  "component---src-pages-dao-tsx": () => import("./../../../src/pages/dao.tsx" /* webpackChunkName: "component---src-pages-dao-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

